import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css']
})
export class SnackbarComponent implements OnInit {
	@Input() childShow; // show boolean
  @Input() childMessage; // student String

  constructor(
  ) { 

  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// ./src/app/component/shared/snackbar_component/snackbar.component.ts